import {
  Dialog,
  Bar,
  Text,
  Title,
  TitleLevel,
  Button,
  ButtonDesign
} from '@ui5/webcomponents-react';
import { useTranslation } from 'react-i18next';

export type CopyEmailContentToClipboardDialogProps = {
  email: string;
  content: string;
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
};

export const CopyEmailContentToClipboardDialog: React.FC<CopyEmailContentToClipboardDialogProps> = (
  props
) => {
  const { email, content, isOpen, setIsOpen } = props;
  const { t } = useTranslation();

  const onConfirm = async () => {
    if (email) {
      const uri = `mailto:${encodeURIComponent(email)}?subject=${encodeURIComponent(
        t('email-subject')
      )}&body=${encodeURIComponent(t('copy-email-content-dialog-body'))}`;

      await navigator.clipboard.writeText(content).then(() => {
        location.assign(uri);
        setIsOpen(false);
      });
    }
  };

  return (
    <Dialog
      data-testid="copy-email-content-dialog"
      open={isOpen}
      header={
        <Bar>
          <Title level={TitleLevel.H3}>{t('copy-email-content-dialog-length-exceeded')}</Title>
        </Bar>
      }
      footer={
        <Bar
          endContent={
            <>
              <Button
                onClick={() => onConfirm()}
                design={ButtonDesign.Emphasized}
                key="copy-email-content-dialog-confirm-button"
                data-testid="copy-email-content-dialog-confirm-button"
              >
                {t('copy-email-content-dialog-confirm-yes')}
              </Button>
              <Button
                onClick={() => setIsOpen(false)}
                key="copy-email-content-dialog-cancel-button"
                data-testid="copy-email-content-dialog-cancel-button"
              >
                {t('copy-email-content-dialog-confirm-no')}
              </Button>
            </>
          }
        />
      }
    >
      <Text>{t('copy-email-content-dialog-confirmation')}</Text>
    </Dialog>
  );
};
